export const LANGUAGES = {
  EN: 'en',
  PT_BR: 'pt_BR',
  ES: 'es'
};